<template>
  <!-- <div style="display: flex;flex-direction: column;flex-grow: 1;">
    <div style="display: flex;align-items: center;justify-content: space-between;font-weight: bold;font-size: 16px;margin-top:3px;margin-bottom: 0px;background-color: #d3f1ff;padding: 3px;" @click="showDetails=!showDetails">
      <div>{{ index }}. <span style="text-decoration:underline;font-size: 16px;">{{ data.jobNo }}</span></div>
      <img :src="icon" height="16px">
    </div>
    <slot :show="showDetails" />
  </div> -->
  <div class="table-list">
    <div class="list-show" @click="canShowDetail">
      <label>{{ index }}</label>
      <span>{{ data.jobNo }}</span>
      <div>
        <img :src="icon" alt="" :class="currentState === 'checking' ? 'animate' : ''">
        <el-popover
          placement="right"
          width="400"
          trigger="hover"
          style="width: 100%"
        >
          <el-table :data="disposeExplainData" border>
            <el-table-column width="200" property="gpExplain" label="GP备注" />
            <el-table-column width="200" property="arapExplain" label="ARAP解释" />
          </el-table>
          <img v-show="isArAp && Object.keys(explainData).length > 0" slot="reference" src="@/assets/icons/bg-right.png" style="margin-left: 10px;">
        </el-popover>
      </div>
    </div>
    <div class="list-hide">
      <slot :show="showDetails" />
    </div>
  </div>
</template>

<script>

import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'

const states = {
  checking: 'checking',
  success: 'success',
  warning: 'warning',
  failure: 'failure',
  stay: 'stay'
}
import acceptIcon from '@/assets/accept-x16.png'
import warningIcon from '@/assets/warning-x16.png'
import loadingIcon from '@/assets/loading-x32.png'
import rejectIcon from '@/assets/reject-x16.png'
import clockIcon from '@/assets/clock-x32.png'
export default {
  name: 'SimpleCheckItemRenderer',
  props: {
    data: { type: Object, default: () => { return {} } },
    index: { type: Number, default: 0 },
    node: { type: Number, default: 0 },
    explainData: { type: Object, default: () => { return {} } }
  },
  data() {
    return {
      states,
      currentState: states.stay,
      showDetails: false
    }
  },
  computed: {
    icon() {
      let iconImg = ''
      switch (this.currentState) {
        case states.checking:
          iconImg = loadingIcon
          break
        case states.success:
          iconImg = acceptIcon
          break
        case states.warning:
          iconImg = warningIcon
          break
        case states.failure:
          iconImg = rejectIcon
          break
        case states.stay:
          iconImg = clockIcon
          break
      }
      return iconImg
    },
    isArAp() {
      if (this.node && (this.node === CheckRuleConstants.NODE_AR_SURE.code ||
        this.node === CheckRuleConstants.NODE_AP_SURE.code ||
        this.node === CheckRuleConstants.NODE_AR_RECHECK.code ||
        this.node === CheckRuleConstants.NODE_AP_RECHECK.code)) {
        return true
      }
      return false
    },
    disposeExplainData() {
      if (this.data.key && Object.keys(this.explainData).length > 0 && this.explainData[this.data.key]) {
        return [{
          'gpExplain': this.explainData[this.data.key].gpExplainRecord,
          'arapExplain': this.explainData[this.data.key].arapExplain
        }]
      } else {
        return []
      }
    }
  },
  watch: {
    data: {
      handler(val) {
        this.init()
      },
      deep: true
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.currentState = this.data.state
    },
    canShowDetail() {
      if (this.currentState != states.success) {
        this.showDetails = !this.showDetails
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-list{
  width: 100%;
  line-height: 30px;
  border-bottom: 1px solid #E9EBEF;
  font-size: 14px;
  .list-show{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    label{
      width: 10%;
    }
    span{
      width: 60%;
      // text-align: left;
    }
    img{
      width: 18px;
      margin-left: 80px;
    }
    .animate{
      animation: loadingAnimation 2s infinite;
      -webkit-animation: loadingAnimation 2s infinite;
      -moz-animation: loadingAnimation 2s infinite;
      -o-animation: loadingAnimation 2s infinite;
    }
  }
  .list-hide{
    width: 100%;
    .check-item-renderer{
      border: 0;
      border-top: 1px solid #E9EBEF;
    }
  }
}

@keyframes loadingAnimation{
  0%{
    transform:rotate(0deg)
  }
  100%{
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loadingAnimation{
  0%{
    transform:rotate(0deg)
  }
  100%{
    transform: rotate(360deg);
  }
}

@-moz-keyframes loadingAnimation{
  0%{
    transform:rotate(0deg)
  }
  100%{
    transform: rotate(360deg);
  }
}

@-o-keyframes loadingAnimation{
  0%{
    transform:rotate(0deg)
  }
  100%{
    transform: rotate(360deg);
  }
}
</style>
